import { eGuaranteeTypes } from "@ntprsrf-frontend/internet/src/constants/APIEnums";
import { RouteRecordRaw } from "vue-router";
import { eloaAudit } from "@ntprsrf-frontend/service/src/services/internet/eloa.service";
import { ELOAAuditRequest } from "@ntprsrf-frontend/service/src/requests/internet/eloa.request";
import vdpRoutes from "./vdp.route";

const governmentServiceRoute: RouteRecordRaw[] = [
  {
    path: "eservices",
    name: "GOVERNMENT_SERVICES_REBRAND",
    meta: {
      label: "Government Services",
      hideBreadcrumb: true,
    },
    alias: "government-services",
    redirect: () => {
      return {
        name: "PERMIT_RETURN",
      };
    },
    children: [
      {
        path: "search",
        name: "GOVERNMENT_SERVICES_SEARCH_PAGE",
        component: () => import("@/views/GovernmentServices/EServices/Category.vue"),
        meta: {
          rebrand: true,
          isInformationalService: true,
          label: "eServices",
        }
      },
      {
        path: "list",
        name: "GOVERNMENT_SERVICES_LIST",
        component: () => import("@/views/GovernmentServices/EServices/Index.vue"),
        meta: {
          rebrand: true,
          isInformationalService: true,
          ignoresAuth: true,
          label: "eServices",
        }
      },
      {
        path: "favourites-list",
        name: "FAVOURITE_GOVERNMENT_SERVICES_LIST",
        component: () => import("@/views/GovernmentServices/EServices/Index.vue"),
        meta: {
          rebrand: true,
          isInformationalService: true,
          label: "eServices",
        }
      },
      {
        path: "permit-clearance-enquiry",
        name: "PERMIT_CLEARANCE_ENQUIRY",
        meta: {
          rebrand: true,
          transactionalServiceId: 'ntp-5023',
          ignoresAuth: true,
          label: "Permit Clearance Enquiry",
          eGuaranteeTypesCanAccess: [
            eGuaranteeTypes.NORMAL.VALUE,
            eGuaranteeTypes.FINANCIAL_INSTITUTION.VALUE,
            eGuaranteeTypes.GOVERNMENT_AGENCY.VALUE,
          ],
        },
        component: () =>
          import("@/views/GovernmentServices/PermitClearance.vue"),
      },
      {
        meta: {
          rebrand: true,
          label: "Permit Return",
          eGuaranteeTypesCanAccess: [
            eGuaranteeTypes.NORMAL.VALUE,
            eGuaranteeTypes.FINANCIAL_INSTITUTION.VALUE,
            eGuaranteeTypes.GOVERNMENT_AGENCY.VALUE,
          ],
          breadcrumb: (route: RouteRecordRaw) => ({
            label : route.meta?.customBreadcrumb ?? "Permit Return",
            title: route.meta?.breadcrumbTitle ?? "Permit Return",
            to: { name: "PERMIT_RETURN" },
          })
        },
        name: "PERMIT_RETURN",
        path: "permit-return",
        redirect: () => {
          return {
            name: "SEARCH_UI",
          };
        },
        component: () => import("@/views/GovernmentServices/PermitReturn/Index.vue"),
        children: [
          {
            path: "search",
            name: "SEARCH_UI",
            component: () => import("@/views/GovernmentServices/PermitReturn/SearchUI.vue"),
            meta: {
              rebrand: true,
              label: "Search",
              transactionalServiceId: 'ntp-5021',
              eGuaranteeTypesCanAccess: [
                eGuaranteeTypes.NORMAL.VALUE,
                eGuaranteeTypes.FINANCIAL_INSTITUTION.VALUE,
                eGuaranteeTypes.GOVERNMENT_AGENCY.VALUE,
              ],
              hideBreadcrumb: true
            },
          },
          {
            path: "my-permits",
            name: "MY_PERMITS",
            component: () => import("@/views/GovernmentServices/PermitReturn/MyPermits.vue"),
            meta: {
              rebrand: true,
              label: "My Permits",
              eGuaranteeTypesCanAccess: [
                eGuaranteeTypes.NORMAL.VALUE,
                eGuaranteeTypes.FINANCIAL_INSTITUTION.VALUE,
              ],
              hideBreadcrumb: true
            },
          },
          {
            path: "data-consent",
            name: "DATA_CONSENT",
            meta: {
              rebrand: true,
              label: "Data Consent",
              eGuaranteeTypesCanAccess: [
                eGuaranteeTypes.NORMAL.VALUE,
                eGuaranteeTypes.FINANCIAL_INSTITUTION.VALUE,
              ],
              hideBreadcrumb: true
            },
            component: () =>
              import("@/views/GovernmentServices/PermitReturn/DataConsent.vue"),
          },
          {
            path: "received-permits",
            name: "RECEIVED_PERMITS",
            component: () => import("@/views/GovernmentServices/PermitReturn/ReceivedPermit.vue"),
            meta: {
              rebrand: true,
              label: "Received Permit",
              eGuaranteeTypesCanAccess: [
                eGuaranteeTypes.NORMAL.VALUE,
                eGuaranteeTypes.FINANCIAL_INSTITUTION.VALUE,
              ],
              isReceivedPermit: true,
              hideBreadcrumb: true
            },
          },
        ],
      },
      {
        path: "e-guarantee",
        name: "E_GUARANTEE@GOV",
        redirect() {
          return {
            name: "E_GUARANTEE@GOV_LIST",

          };
        },
        meta: {
          label: "eGuarantee@Gov",
          eGuaranteeTypesCanAccess: [
            eGuaranteeTypes.FINANCIAL_INSTITUTION.VALUE,
            eGuaranteeTypes.GOVERNMENT_AGENCY.VALUE,
          ],
          rebrand: true,
        },
        component: () => import("@/views/GovernmentServices/EGuarantee@Gov/Index.vue"),
        children: [
          {
            path: "files-shared-by",
            name: "E_GUARANTEE@GOV_LIST",
            meta: {
              eGuaranteeTypesCanAccess: [
                eGuaranteeTypes.FINANCIAL_INSTITUTION.VALUE,
                eGuaranteeTypes.GOVERNMENT_AGENCY.VALUE,
              ],
              rebrand: true,
              hideBreadcrumb: true,
            },
            component: () => import("@/views/GovernmentServices/EGuarantee@Gov/Received.vue"),
          },
          {
            path: "share-files-with",
            name: "E_GUARANTEE@SENT_LIST",
            meta: {
              eGuaranteeTypesCanAccess: [
                eGuaranteeTypes.FINANCIAL_INSTITUTION.VALUE,
                eGuaranteeTypes.GOVERNMENT_AGENCY.VALUE,
              ],
              rebrand: true,
              hideBreadcrumb: true,
            },
            component: () => import("@/views/GovernmentServices/EGuarantee@Gov/SentTo.vue"),
          },
          {
            path: ":companyUEN",
            meta: {
              breadcrumbParam: "companyUEN",
              rebrand: true,
              isCompanyStore: true,
              hideBreadcrumb: true
            },
            redirect() {
              return {
                name: "E_GUARANTEE@GOV",
              };
            },
            name: "E_GUARANTEE_TO_COMPANIES",
            children: [
              {
                path: "add-file",
                component: () =>
                  import("@/views/GovernmentServices/EGuarantee@Gov/AddEGuaranteeFiles.vue"),
                name: "E_GUARANTEE_ADD_FILES",
                meta: {
                  rebrand: true,
                  label: "Share eGuarantee files",
                  eGuaranteeTypesCanAccess: [
                    eGuaranteeTypes.FINANCIAL_INSTITUTION.VALUE,
                    eGuaranteeTypes.GOVERNMENT_AGENCY.VALUE,
                  ],
                  breadcrumb: (route: RouteRecordRaw) => ({
                    label : route.meta?.customBreadcrumb ?? "Share eGuarantee files",
                    title: route.meta?.breadcrumbTitle ?? "Share eGuarantee files",
                    to: { name: "E_GUARANTEE_ADD_FILES" },
                  })
                },
              },
            ],
          },
          {
            path: "add-beneficiary-file",
            component: () =>
              import("@/views/GovernmentServices/EGuarantee@Gov/AddEGuaranteeFiles.vue"),
            name: "E_GUARANTEE_BENEFICIARY_FILE",
            meta: {
            rebrand: true,
              label: "Share eGuarantee files",
              eGuaranteeTypesCanAccess: [
                eGuaranteeTypes.FINANCIAL_INSTITUTION.VALUE,
              ],
            },
          },
        ],
      },
      {
        path: "container-track-and-trace",
        name: "CONTAINER_TRACK_AND_TRACE",
        meta: {
          transactionalServiceId: 'ntp-5024',
          rebrand: true,
          label: "Container Track and Trace",
          eGuaranteeTypesCanAccess: [
            eGuaranteeTypes.NORMAL.VALUE,
            eGuaranteeTypes.FINANCIAL_INSTITUTION.VALUE,
            eGuaranteeTypes.GOVERNMENT_AGENCY.VALUE,
          ],
        },
        component: () =>
          import("@/views/GovernmentServices/ContainerTrackAndTrace/Index.vue"),
      },
      {
        path: "hand-carried-exports-scheme",
        name: "HAND_CARRIED_EXPORTS_SCHEME",
        meta: {
          transactionalServiceId: 'ntp-5025',
          label: "Hand-Carried Exports Scheme (HCES) Digital Service",
          rebrand:true,
          eGuaranteeTypesCanAccess: [
            eGuaranteeTypes.NORMAL.VALUE,
            eGuaranteeTypes.FINANCIAL_INSTITUTION.VALUE,
            eGuaranteeTypes.GOVERNMENT_AGENCY.VALUE,
          ],
        },
        component: () =>
          import("@/views/GovernmentServices/HandCarriedExportScheme/Index.vue"),
      },
      {
        path: "pending-payment",
        meta: {
          label: "Select Case Reference to Pay Duty, GST and Composition Sum",
          rebrand: true,
          eGuaranteeTypesCanAccess: [
            eGuaranteeTypes.NORMAL.VALUE,
            eGuaranteeTypes.FINANCIAL_INSTITUTION.VALUE,
            eGuaranteeTypes.GOVERNMENT_AGENCY.VALUE,
          ],
        },
        children: [
          {
            path: "",
            name: "ELOA",
            component: () => import("@/views/GovernmentServices/eLOA/PendingPayment.vue"),
            meta: {
              serviceName: "eLOA",
              label: "Select Case Reference to Pay Duty, GST and Composition Sum",
              hideBreadcrumb: true,
              rebrand: true,
              pageIndex: 1,
              auditFn: (params: ELOAAuditRequest) => eloaAudit(params),
              eGuaranteeTypesCanAccess: [
                eGuaranteeTypes.NORMAL.VALUE,
                eGuaranteeTypes.FINANCIAL_INSTITUTION.VALUE,
                eGuaranteeTypes.GOVERNMENT_AGENCY.VALUE,
              ],
            },
          },
          {
            path: "payment-method",
            name: "PAYMENT_METHOD",
            component: () => import("@/views/GovernmentServices/eLOA/PaymentMethod.vue"),
            meta: {
              serviceName: "eLOA",
              label: "Payment Method & Confirmation",
              rebrand: true,
              pageIndex: 2,
              auditFn: (params: ELOAAuditRequest) => eloaAudit(params),
              eGuaranteeTypesCanAccess: [
                eGuaranteeTypes.NORMAL.VALUE,
                eGuaranteeTypes.FINANCIAL_INSTITUTION.VALUE,
                eGuaranteeTypes.GOVERNMENT_AGENCY.VALUE,
              ],
            },
          },
          {
            path: "payment-summary",
            meta: {
              label: "Payment Method & Confirmation",
              rebrand: true,
              eGuaranteeTypesCanAccess: [
                eGuaranteeTypes.NORMAL.VALUE,
                eGuaranteeTypes.FINANCIAL_INSTITUTION.VALUE,
                eGuaranteeTypes.GOVERNMENT_AGENCY.VALUE,
              ],
              disableBreadcrumbClick: true
            },
            children: [
              {
                path: "",
                name: "PAYMENT_SUMMARY",
                component: () => import("@/views/GovernmentServices/eLOA/PaymentSummary.vue"),
                meta: {
                  serviceName: "eLOA",
                  label: "Payment Transaction Summary",
                  rebrand: true,
                  pageIndex: 3,
                  auditFn: (params: ELOAAuditRequest) => eloaAudit(params),
                  eGuaranteeTypesCanAccess: [
                    eGuaranteeTypes.NORMAL.VALUE,
                    eGuaranteeTypes.FINANCIAL_INSTITUTION.VALUE,
                    eGuaranteeTypes.GOVERNMENT_AGENCY.VALUE,
                  ]
                },
              },
            ]
          },
          {
            path: "outstanding-axs-transactions",
            name: "OUTSTANDING_AXS_TRANSACTIONS",
            component: () => import("@/views/GovernmentServices/eLOA/OutstandingAXSTransactions.vue"),
            meta: {
              rebrand: true,
              serviceName: "eLOA",
              label: "Outstanding AXS Transactions",
            },
          },
        ],
      },
      ...vdpRoutes,
    ],
  },
];

export default governmentServiceRoute;
